import { Kind } from 'graphql';
import inputSchema from './input-schema.json';

const invalid = () => { const error = new Error('Invalid form data'); error.status = 400; throw error; };
const clean = (value, type) => {
  if (typeof value === 'number' && !Number.isFinite(value)) invalid();
  if (value instanceof Date && !Number.isFinite(value.getTime())) invalid();
  if (value === undefined || value === null || (value === '' && ['Int', 'Float'].includes(type.name))) {
    if (type.required) invalid();
    return value === undefined ? undefined : null;
  }
  if (type.list) {
    if (!Array.isArray(value)) invalid();
    return value.map(item => clean(item, type.list));
  }
  if (inputSchema[type.name]) {
    if (typeof value !== 'object' || Array.isArray(value)) invalid();
    const result = {};
    for (const [key, fieldType] of Object.entries(inputSchema[type.name])) {
      const field = clean(value[key], fieldType);
      if (field !== undefined) result[key] = field;
    }
    return result;
  }
  if (['Int', 'Float'].includes(type.name)) {
    if (typeof value !== 'number' || !Number.isFinite(value) || (type.name === 'Int' && (!Number.isInteger(value) || value < -2147483648 || value > 2147483647))) invalid();
  }
  if (type.name === 'Boolean' && typeof value !== 'boolean') invalid();
  if (type.name === 'String' && typeof value !== 'string') invalid();
  return value;
};
const describeType = type => type.kind === Kind.NON_NULL_TYPE ? { ...describeType(type.type), required: true } : type.kind === Kind.LIST_TYPE ? { list: describeType(type.type) } : { name: type.name.value };
export const sanitizeVariables = (query, variables = {}) => {
  const operation = query.definitions.find(definition => definition.kind === Kind.OPERATION_DEFINITION);
  if (operation?.operation !== 'mutation') return variables;
  const result = {};
  for (const definition of operation.variableDefinitions || []) {
    const name = definition.variable.name.value;
    const value = clean(variables[name], describeType(definition.type));
    if (value !== undefined) result[name] = value;
  }
  return result;
};
